import { db } from './firebase';
import {
    collection,
    addDoc,
    getDocs,
    doc,
    updateDoc,
    deleteDoc,
    query,
    orderBy,
    Timestamp,
    onSnapshot
} from 'firebase/firestore';

console.log("[Services] ✅ Firestore services inicializado");

const COLLECTION_NAME = 'comerciales';

// ============ FUNCIÓN SIMPLIFICADA Y GARANTIZADA ============
export const createComercial = async (comercialData) => {
    try {
        console.log("[Services] 🚀 Creando comercial...");

        // 1. PREPARAR DATOS CON FORMATO EXACTO QUE FIRESTORE ACEPTA
        const firestoreData = {
            // Campos de texto (asegurar string)
            titulo: String(comercialData.titulo || 'Sin título'),
            orientacion: String(comercialData.orientacion || 'Horizontal'),
            estado: String(comercialData.estado || 'offline'),
            usuario: String(comercialData.usuario || 'Usuario'),
            comentarios: String(comercialData.comentarios || ''),
            videoUrl: String(comercialData.videoUrl || ''),
            thumbnail: String(comercialData.thumbnail || ''),
            fileName: String(comercialData.fileName || 'video.mp4'),

            // Campos numéricos
            duracion: Number(comercialData.duracion) || 0,
            fileSize: Number(comercialData.fileSize) || 0,

            // Fechas - USAR Timestamp.now() SOLAMENTE
            fechaRegistro: Timestamp.now(),

            // Segmentación (asegurar estructura válida)
            segmentacion: {
                tipo: String(comercialData.segmentacion?.tipo || 'Nacional'),
                region: String(comercialData.segmentacion?.region || ''),
                ciudad: Array.isArray(comercialData.segmentacion?.ciudad)
                    ? comercialData.segmentacion.ciudad.map(String)
                    : [],
                tienda: Array.isArray(comercialData.segmentacion?.tienda)
                    ? comercialData.segmentacion.tienda.map(String)
                    : []
            },

            // Schedule (convertir a strings ISO)
            scheduleStart: String(comercialData.scheduleStart || new Date().toISOString()),
            scheduleEnd: String(comercialData.scheduleEnd || new Date().toISOString()),
            dailyStartTime: String(comercialData.dailyStartTime || '08:00'),
            dailyEndTime: String(comercialData.dailyEndTime || '20:00'),

            // Booleanos
            solicitudBaja: Boolean(comercialData.solicitudBaja || false),
            isDuplicate: Boolean(comercialData.isDuplicate || false),
            tempId: String(comercialData.tempId || '')
        };

        console.log("[Services] 📤 Datos preparados para Firestore:", {
            titulo: firestoreData.titulo,
            estado: firestoreData.estado,
            tieneVideoUrl: !!firestoreData.videoUrl
        });

        // 2. ESCRIBIR EN FIRESTORE (método directo y simple)
        const docRef = await addDoc(collection(db, COLLECTION_NAME), firestoreData);

        console.log("[Services] ✅✅✅ DOCUMENTO CREADO EXITOSAMENTE EN FIRESTORE!");
        console.log("📝 ID del documento:", docRef.id);
        console.log("📝 Colección:", COLLECTION_NAME);
        console.log("📝 Proyecto:", db.app.options.projectId);

        // 3. RETORNAR DATOS CONFIRMADOS
        return {
            id: docRef.id,
            ...firestoreData,
            fechaRegistro: new Date().toISOString() // Para UI inmediata
        };

    } catch (error) {
        console.error("[Services] ❌❌❌ ERROR CRÍTICO EN FIRESTORE:", error);
        console.error("Código:", error.code);
        console.error("Mensaje:", error.message);
        console.error("Stack:", error.stack);

        // Error específico para UI
        throw new Error(`Firestore Error [${error.code}]: ${error.message}`);
    }
};

// ============ FUNCIONES SIMPLIFICADAS ============
export const updateComercial = async (id, data) => {
    try {
        const docRef = doc(db, COLLECTION_NAME, id);
        await updateDoc(docRef, {
            ...data,
            updatedAt: Timestamp.now()
        });
        return true;
    } catch (error) {
        console.error("Update error:", error);
        throw error;
    }
};

export const getComerciales = async () => {
    try {
        const q = query(collection(db, COLLECTION_NAME));
        const querySnapshot = await getDocs(q);

        return querySnapshot.docs.map(docSnap => {
            const data = docSnap.data();

            // Convertir Timestamp a Date para UI
            let fechaRegistro = new Date();
            if (data.fechaRegistro && data.fechaRegistro.toDate) {
                fechaRegistro = data.fechaRegistro.toDate();
            }

            return {
                id: docSnap.id,
                ...data,
                fechaRegistro: fechaRegistro,
                fechaRegistroISO: fechaRegistro.toISOString()
            };
        });
    } catch (error) {
        console.error("Get comerciales error:", error);
        return [];
    }
};

export const deleteComercial = async (id) => {
    try {
        await deleteDoc(doc(db, COLLECTION_NAME, id));
        return true;
    } catch (error) {
        console.error("Delete error:", error);
        throw error;
    }
};

export const subscribeToComerciales = (callback) => {
    try {
        const q = query(collection(db, COLLECTION_NAME));

        return onSnapshot(q,
            (snapshot) => {
                const comerciales = snapshot.docs.map(docSnap => {
                    const data = docSnap.data();

                    let fechaRegistro = new Date();
                    if (data.fechaRegistro && data.fechaRegistro.toDate) {
                        fechaRegistro = data.fechaRegistro.toDate();
                    }

                    return {
                        id: docSnap.id,
                        ...data,
                        fechaRegistro: fechaRegistro,
                        fechaRegistroISO: fechaRegistro.toISOString()
                    };
                });

                callback(comerciales, null, snapshot.metadata);
            },
            (error) => {
                console.error("Listener error:", error);
                callback([], error, null);
            }
        );
    } catch (error) {
        console.error("Setup listener error:", error);
        callback([], error, null);
        return () => { };
    }
};